import { render, staticRenderFns } from "./RiskModelCatalogs.vue?vue&type=template&id=7549a49e&scoped=true&"
import script from "./RiskModelCatalogs.vue?vue&type=script&lang=js&"
export * from "./RiskModelCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7549a49e",
  null
  
)

export default component.exports